import { useCallback, useEffect, useState } from "react";
import { api, errorMessage } from "./api";

export const useFetch = (url, params) => {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const key = JSON.stringify(params || {});

  const load = useCallback(() => {
    setState({ data: null, loading: true, error: null });
    api
      .get(url, { params: JSON.parse(key) })
      .then((r) => setState({ data: r.data, loading: false, error: null }))
      .catch((e) => setState({ data: null, loading: false, error: errorMessage(e) }));
  }, [url, key]);

  useEffect(() => {
    load();
  }, [load]);

  return { ...state, retry: load };
};
